import styled from 'styled-components'

import { BaseAlert } from './BaseAlert'

export const DiscoverAlert = styled(BaseAlert)`
  background-color: ${(props) => props.theme.colors.alert.discover.background};

  border-color: ${(props) => props.theme.colors.alert.discover.border};
`

DiscoverAlert.displayName = 'DiscoverAlert'
